import { api } from "jiffy-api";
import { isMobileBrowser, isPhone, isTablet } from "common/utils/browser";

// eslint-disable-next-line import/prefer-default-export
export class ProductsFilterModalLoader {
  #gettingFilters = false;

  #filtersWrapperSelector;

  #filtersLoaderSelector;

  #loadingCallback = null;

  #hiddenClassName = "hidden";

  constructor(props) {
    this.#filtersWrapperSelector = props.filtersWrapperSelector;
    this.#filtersLoaderSelector = props.filtersLoaderSelector;
    this.#loadingCallback = props.loadingCallback || null;
  }

  get #$filtersContainer() {
    return document.querySelector(this.#filtersWrapperSelector);
  }

  get #$filtersLoader() {
    return document.querySelector(this.#filtersLoaderSelector);
  }

  static get filtersParams() {
    try {
      const url = new URL(window.location.href);
      const isCanadian = document.documentElement.lang === "en-CA";
      const pathSegments = url.pathname.split("/").filter(Boolean);
      // Extract category slug accounting for store prefix
      const categorySlug = isCanadian ? pathSegments[1] || "" : pathSegments[0] || "";

      // More robust PDP detection
      if (categorySlug.includes(".") || pathSegments.some(segment => segment.includes("."))) {
        return {};
      }

      return Array.from(url.searchParams).reduce(
        (acc, [key, value]) => {
          if (acc[key] && Array.isArray(acc[key])) {
            acc[key].push(value);
          } else if (acc[key]) {
            acc[key] = [acc[key], value];
          } else {
            acc[key] = value;
          }
          return acc;
        },
        {
          category_slug: categorySlug
        }
      );
    } catch (error) {
      console.error("Error parsing URL parameters:", error);
      return {};
    }
  }

  async getFilters() {
    if (this.#gettingFilters) return;

    this.#gettingFilters = true;

    try {
      const { html } = await api.jiffyshirts.facetsFilters(ProductsFilterModalLoader.filtersParams);

      if (!html || typeof html !== "string") {
        throw new Error("Invalid HTML response from API");
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const filterContent = doc.body.firstChild;

      if (filterContent) {
        this.#$filtersContainer?.appendChild(filterContent);
        this.#loadingCallback?.();
      }
    } catch (error) {
      this.#gettingFilters = false;
    } finally {
      this.#$filtersLoader?.classList.add(this.#hiddenClassName);
    }
  }

  async autoLoadingMobileFilters() {
    const isMobile = () => isPhone() || isMobileBrowser() || isTablet();

    if (!isMobile()) return;

    await this.getFilters();
  }
}
